/**
 * Thin React HUD overlay shown during play. Deliberately does NOT show the live
 * score (that's drawn inside the Phaser canvas). It only carries a back-to-menu
 * button — the "players online" count is intentionally omitted in-game (it lives in
 * the POPSTAR network section instead).
 */
interface HudProps {
  onMenu: () => void;
}

export function Hud({ onMenu }: HudProps) {
  return (
    <div className="hud">
      <button className="btn btn-ghost hud-menu" onClick={onMenu}>
        ☰ Menu
      </button>
    </div>
  );
}
